import { render, staticRenderFns } from "./roleForm.vue?vue&type=template&id=1151901c&scoped=true&"
import script from "./roleForm.vue?vue&type=script&lang=js&"
export * from "./roleForm.vue?vue&type=script&lang=js&"
import style0 from "./roleForm.vue?vue&type=style&index=0&id=1151901c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1151901c",
  null
  
)

export default component.exports